exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vip-card-wrap[data-v-782dcef0]{width:100%;min-height:100vh;background:#eeeff0;padding-bottom:4rem\n}", "", {"version":3,"sources":["/workspace/workspace/GTGJ-H5-Pro/GTGJ-Wap-Prod/src/projects/vipCard/pages/home/index.vue"],"names":[],"mappings":";AACA,gCAAgC,WAAW,iBAAiB,mBAAmB,mBAAmB;CACjG","file":"index.vue","sourcesContent":["\n.vip-card-wrap[data-v-782dcef0]{width:100%;min-height:100vh;background:#eeeff0;padding-bottom:4rem\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-782dcef0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/projects/vipCard/pages/home/index.vue
// module id = u5Yv
// module chunks = 1